import { useTranslation } from 'react-i18next';
import { Page } from '@/components/layout/Page';
import { PageHeader } from '@/components/layout/PageHeader';
import { PageContent } from '@/components/layout/PageContent';

export function TermsPage() {
    const { t } = useTranslation('legal');

    return (
        <Page className="bg-slate-50">
            <PageHeader title={t('terms.title')} backLink="/" width="narrow" />

            <PageContent width="narrow">
                <div className="space-y-6 pb-8">

                    {/* Preamble */}
                    <Section title={t('terms.preamble.title')}>
                        <p>{t('terms.preamble.content')}</p>
                    </Section>

                    {/* Object */}
                    <Section title={t('terms.object.title')}>
                        <p>{t('terms.object.content')}</p>
                    </Section>

                    {/* Registration */}
                    <Section title={t('terms.registration.title')}>
                        <p>{t('terms.registration.content')}</p>
                    </Section>

                    {/* Usage */}
                    <Section title={t('terms.usage.title')}>
                        <p>{t('terms.usage.rules')}</p>
                        <ul className="list-disc pl-5 space-y-1 mt-2">
                            {([1, 2, 3, 4, 5] as const).map((n) => (
                                <li key={n}>{t(`terms.usage.rule${n}`)}</li>
                            ))}
                        </ul>
                    </Section>

                    {/* Races */}
                    <Section title={t('terms.races.title')}>
                        <p>{t('terms.races.content')}</p>
                    </Section>

                    {/* Intellectual */}
                    <Section title={t('terms.intellectual.title')}>
                        <p>{t('terms.intellectual.content')}</p>
                    </Section>

                    {/* Liability */}
                    <Section title={t('terms.liability.title')}>
                        <p>{t('terms.liability.content1')}</p>
                        <p className="mt-2">{t('terms.liability.content2')}</p>
                        <ul className="list-disc pl-5 space-y-1 mt-2">
                            {([1, 2, 3, 4] as const).map((n) => (
                                <li key={n}>{t(`terms.liability.item${n}`)}</li>
                            ))}
                        </ul>
                    </Section>

                    {/* Suspension */}
                    <Section title={t('terms.suspension.title')}>
                        <p>{t('terms.suspension.content')}</p>
                    </Section>

                    {/* Modifications */}
                    <Section title={t('terms.modifications.title')}>
                        <p>{t('terms.modifications.content')}</p>
                    </Section>

                    {/* Applicable */}
                    <Section title={t('terms.applicable.title')}>
                        <p>{t('terms.applicable.content')}</p>
                    </Section>

                    <p className="text-xs text-slate-400 text-center pt-2">{t('terms.lastUpdate')}</p>
                </div>
            </PageContent>
        </Page>
    );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-3">
            <h2 className="text-sm font-bold text-slate-900">{title}</h2>
            <div className="text-sm text-slate-600 leading-relaxed">{children}</div>
        </div>
    );
}
